export const iconFontAwesomeSocialUserGroup = (
	<i className="fa-solid fa-user-group"></i>
);
